module.exports = __webpack_public_path__ + "static/media/uy.7942bb43.svg";